import { defineStore } from 'pinia'
import { computed } from 'vue'
import { useBoostCorePermissionStore } from '@/stores/useBoostCorePermissionStore'

export type LayoutMode = 'v1' | 'v2'

export const HOME_PATH_V1 = '/'
export const HOME_PATH_V2 = '/accueil'

/**
 * Mode actif (V1 vs V2) — entièrement piloté par la BU de l'utilisateur
 * (préférence `layoutApy`, exposée par /auth/user/me). Pas de bascule manuelle :
 * un user reste dans le périmètre défini par sa BU (V2 si sa BU l'a activé, sinon V1).
 */
export const useLayoutModeStore = defineStore('layoutMode', () => {
  const boostCoreStore = useBoostCorePermissionStore()

  const effectiveMode = computed<LayoutMode>(() => (boostCoreStore.layoutApy ? 'v2' : 'v1'))

  return { effectiveMode }
})
